import AWS from 'aws-sdk'
export const awsRegion = 'us-east-1'
export const cognitoRegion = 'us-east-1'
export const cognitoUserPoolId = 'us-east-1_JTsi9WZoU'
export const cognitoIdentityPoolId = 'us-east-1:9d257212-d642-40ab-990d-33df3b4c9e9e'
export const cognitoClientId = '4opanb24cuaaq1niqg8bqb8bh7'

AWS.config.region = cognitoRegion



/** WEBPACK FOOTER **
 ** ./src/services/aws.js
 **/